'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _commonicdchangesbydrg = require('./commonicdchangesbydrg.html');

var _commonicdchangesbydrg2 = _interopRequireDefault(_commonicdchangesbydrg);

var _commonicdchangesbydrg3 = require('./commonicdchangesbydrg.controller');

var _commonicdchangesbydrg4 = _interopRequireDefault(_commonicdchangesbydrg3);

require('./commonicdchangesbydrg.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commonicdchangesbydrgComponent = {
  restrict: 'E',
  bindings: {},
  template: _commonicdchangesbydrg2.default,
  controller: _commonicdchangesbydrg4.default,
  controllerAs: 'vm'
};

exports.default = commonicdchangesbydrgComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/commonicdchangesbydrg/commonicdchangesbydrg.component.js